import {Comparator, Predicate, PrimitiveType, Transform} from "../../types/GenericTypes";

export function sum(acc: number, next: number) {
    return acc + next;
}

export function flatMap<T>(acc: ReadonlyArray<T>, next: ReadonlyArray<T>): ReadonlyArray<T> {
    return acc.concat(next);
}

export function distinct<T extends PrimitiveType>(value: T, index: number, arr: Array<T>): boolean {
    return arr.indexOf(value) === index;
}

export function ascending(a: number, b: number): number;
export function ascending(a: string, b: string): number;

export function ascending(a: string | number, b: string | number): number {
    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else {
        return 0;
    }
}

export function ascendingUsing<T>(extractor: Transform<T, string>): Comparator<T>;
export function ascendingUsing<T>(extractor: Transform<T, number>): Comparator<T>;

export function ascendingUsing<T>(extractor: Transform<T, any>): Comparator<T> {
    return (a, b) => {
        const aValue = extractor(a);
        const bValue = extractor(b);
        return ascending(aValue, bValue)
    }
}

export function descending(a: number, b: number): number;
export function descending(a: string, b: string): number;

export function descending(a: string | number, b: string | number): number {
    if (a < b) {
        return 1;
    } else if (a > b) {
        return -1;
    } else {
        return 0;
    }
}

export function descendingUsing<T>(extractor: Transform<T, string>): Comparator<T>;
export function descendingUsing<T>(extractor: Transform<T, number>): Comparator<T>;

export function descendingUsing<T>(extractor: Transform<T, any>): Comparator<T> {
    return (a, b) => {
        const aValue = extractor(a);
        const bValue = extractor(b);
        return descending(aValue, bValue)
    }
}

export function escapeRegExp(value: string) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export function reverse<T>(comparator: Comparator<T> ): Comparator<T> {
    return (a, b) => comparator(a, b) * -1;
}

export function and<T>(a: Predicate<T>, b: Predicate<T>): Predicate<T> {
    return (v) => {
        return a(v) && b(v);
    };
}

export function isNotNull<T>(value: T | undefined | null): value is T {
    return value != null;
}

export function identity<T>() {
    return (val: T) => val;
}

export function noop(...args: Array<any>) {
    return () => {};
}

export function Pair<L, R>(left: L, right: R): [L, R] {
    return [left, right];
}
